import { render, staticRenderFns } from "./AnimeWatchHistory.vue?vue&type=template&id=63ab3d64&"
import script from "./AnimeWatchHistory.vue?vue&type=script&lang=js&"
export * from "./AnimeWatchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports